import { useMutation } from '@tanstack/react-query';

import { useAuthStore } from '../../../core';
import { loginWithGoogle } from '../apis';

export const useGoogleLogin = () => {
  const setAuth = useAuthStore((s) => s.setAuth);

  return useMutation({
    mutationFn: (idToken: string) => loginWithGoogle(idToken),
    onSuccess: (data) => setAuth(data.tokens, data.crew),
  });
};
